import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { NavRouteParams } from '~pricing/components/Navigation/types';

import BackToSummary from '~pricing/experiments/grow_2792_pnp_refresh_v1/components/BackToSummary';
import MainHeading from '~pricing/components/MainHeading';
import DetailsFooter from '~pricing/components/PricingFooter';
import useTrackingDetails from '~pricing/hooks/useTrackingDetails';
import COPY from '~app/pages/Pricing/copy';
import DetailsPackagesView from '~pricing/experiments/grow_2792_pnp_refresh_v1/components/DetailsPackagesView';
import { usePackages } from '~shared/hooks/usePackages';
import { usePricingState } from '~shared/hooks/usePricingState';
/**
 *  This only gets generated on the details page. If canonical path is missing then,
 *  we must be on the /pricing/details (canonical to details), the back link should default to teams summary
 *  with ut_source attached as per legacy billweb
 */

export default function PricingDetailsPage(): JSX.Element {
  const { canonicalPath } = useParams<NavRouteParams>();
  const { allPackages, discountInfo } = usePackages();

  const {
    state: {
      packages: { displayPackages },
    },
  } = usePricingState();
  const { pageUtSource } = useTrackingDetails();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div key="PricingDetails">
      <header>
        <BackToSummary url={createURL(`/pricing/`, { ut_source: pageUtSource })} />
        <MainHeading variant="pageTitle">{t(COPY.DETAILS_HEADING)}</MainHeading>
      </header>
      <DetailsPackagesView
        packageData={displayPackages}
        discountInfo={discountInfo}
        key={`${canonicalPath}-${displayPackages.length}`}
      />
      <DetailsFooter packages={allPackages} />
    </div>
  );
}
